import { render, staticRenderFns } from "./word_eproject.vue?vue&type=template&id=3daec57f&scoped=true"
import script from "./word_eproject.vue?vue&type=script&lang=js"
export * from "./word_eproject.vue?vue&type=script&lang=js"
import style0 from "./word_eproject.vue?vue&type=style&index=0&id=3daec57f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daec57f",
  null
  
)

export default component.exports